/**
 * Track data and projection. Pseudo-3D segments, compiler, projector.
 * See docs/gdd/21-technical-design-for-web-implementation.md §"Suggested module structure".
 */
export * from "./constants";
export * from "./types";
export * from "./minimap";
export * from "./trackCompiler";
export * from "./segmentProjector";
